import { Organization } from '@lucidtech/las-sdk-browser';
import { UseQueryResult } from '@tanstack/react-query';
import { useMemo } from 'react';

import { ListData } from './api';

export const useNewOrganizations = (result: UseQueryResult<ListData<Organization>, Error>) => {
  return useMemo(() => {
    return {
      ...result,
      data: {
        ...result?.data,
        data: result?.data?.data?.filter((org) => org.useNewScopes),
      },
    };
  }, [result]);
};
